<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="title" center width="700px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-fs">

          <div class="df-l-c-ct w100p">
            <div class="f-l">{{$t(isFocus?'scan.waitingScaning':'scan.resetScaning')}}</div>
            <div class="input-box df-l-c-ct">
              <div class="f-l w100p">{{$t('scan.scanResult')}}</div>
              <input type="text" class="hideinput" @focus="onFocus_forScan" @blur="onBlur_forScan" />
              <input type="password" class="hideinput" @focus="onFocus_forScan" @blur="onBlur_forScan" />
              <!-- <input
                ref="elInput" type="password" class="dialog-input f-s" v-model="scanResult"
                @blur="onBlur" @focus="onFocus" @keyup.enter="submitDialog" /> -->
              <input
                ref="elInput" type="text" class="dialog-input f-s" v-model="scanResult_"
                @blur="onBlur" @focus="onFocus" @keyup.enter="submitDialog" @input="onInput" />
            </div>
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <!-- <div class="whitebtn" @click="resetDialog">{{$t('common.clear')}}</div> -->
        <div class="whitebtn" @click="resetDialog">{{$t('scan.rescan')}}</div>
        <div :class="scanResult?'themebtn':'whitebtn'" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogScan',
  data() {
    return {
      isShowDialog: false,
      isFocus: false,
      scanResult: '',
      scanResult_: '',
      title: '',
      suspend: false,
    }
  },
  methods: {
    open() {
      // this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      // this.$emit('close')
      // this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.scanResult_ = ''
      this.scanResult = ''
      this.isFocus = false
    },
    clear() {
      this.scanResult_ = ''
      this.scanResult = ''
    },
    resetDialog() {
      this.scanResult_ = ''
      this.scanResult = ''
      this.$refs.elInput.focus()
    },
    // 支付对话框 提交支付方式
    submitDialog() {
      if (this.scanResult) {
        // 2022-3-31 17:43:34 加个定时器 实现节流
        if (!this.suspend) {

          this.suspend = true

          let timer = setTimeout(() => {
            this.suspend = false
            clearTimeout(timer)
          }, 6000)

          this.$emit('submitDialog', this.scanResult)

        }
      }
    },
    onBlur(e) {
      // @focus="onFocus_forScan" @blur="onBlur_forScan"
      // this.scan_canLeave_x_save(true)
      // this.onBlur_forScan()
      // console.log(`%conBlur的事件:`, 'color: #00f;', e)
      this.isFocus = false
      // if (!this.scanResult) {
      //   this.$refs.elInput.focus()
      // }
    },
    onFocus(e) {
      // @focus="onFocus_forScan" @blur="onBlur_forScan"
      // this.scan_canLeave_x_save(false)
      // this.onFocus_forScan()
      // console.log(`%conFocus的事件:`, 'color: #00f;', e)
      this.isFocus = true
      e.target.setAttribute('readonly', 'readonly')
      // this.$nextTick(() => {
      //   e.target.removeAttribute('readonly')
      // }) // 這個不行
      let timer = setTimeout(() => {
        e.target.removeAttribute('readonly')
        clearTimeout(timer)
      }, 100)
    },
    onInput(e) {
      // console.log(`%conInput的事件:`, 'color: #00f;', e)
      let val = this.scanResult_
      let str = val.substr(val.length-1, 1)
      // console.log(`%c输入的字符:`, 'color: #00f;', str)
      if (str && str !== '*') {
        this.scanResult += str
      } else {
        this.scanResult = this.scanResult.slice(0, this.scanResult.length - 1)
      }
      this.scanResult_ = val.replace(/./g, '*')
      // console.log(`%c保存的字符串:`, 'color: #00f;', this.scanResult)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 40px;height: 250px;
  .input-box{margin: 40px 0;}
  .dialog-input{
    width: 440px;height: 60px;padding: 20px;margin-top: 20px;
    box-sizing: border-box;background: #F4F4F4;
    border: none;resize: none;border-radius: 8px;
  }
}
</style>